import {
    useCallback,
} from 'react'
import useDataGridSource from 'app/PoC/DataGridDemoPages/components/hooks/useDataGridSource'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyBaseCreateButton
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/SkyBaseCreateButton'
import ContactRequests from 'app/requests/Contact.requests'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'
import SkyNetDataGrid from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import {
    DataGridSupportedFeatures,
} from '../components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import columns from './ContactsDemoPage.columns'

const requestConst = ContactRequests.filterRequest()
const toolbarControls = [DataGridSupportedFeatures.ShowArchived]

const ContactsDemoPage = () => {
    const dataSource = useDataGridSource({
        request: requestConst,
        key: 'contactsFilterRequest' as RequestKeys,
    })
    const {
        Contacts: ContactsRoutes,
    } = useContactManagementRoutes()

    const onClick = useCallback(() => {
        ContactsRoutes.Create.navigate()
    }, [ContactsRoutes])

    return (
        <SkyNetDataGrid
            persistentKey="demo-contacts-table"
            height={600}
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: 'Contacts',
                toolbarControls: [<SkyBaseCreateButton onClick={onClick} />],
            }}
            featuresLists={toolbarControls}
        />
    )
}

export default ContactsDemoPage
